import React, {useRef} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

import {BucketCompanyCodeForm, BucketCompanyCodeFormRefHandle} from './BucketCompanyCodeForm';
import {BucketCompanyCode} from 'models/config/BucketCompanyCode';

export type BucketCompanyCodeFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: BucketCompanyCode;
    onSubmit?: (bucketCompanyCode: BucketCompanyCode) => void;
};

export const BucketCompanyCodeFormModal = (
    props: BucketCompanyCodeFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<BucketCompanyCodeFormRefHandle>(null);

    const handleSaveClick = () => {
        const bucketCompanyCode = formRef.current?.submit();
        if (!bucketCompanyCode) {
            return;
        }

        onSubmit?.(bucketCompanyCode);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <BucketCompanyCodeForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="tw-flex tw-justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="tw-border-none tw-bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};